import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from "antd";
import App from './App';
import { BrowserRouter as Router } from "react-router-dom";
import './i18n';
import { useTranslation } from 'react-i18next';
import zhCN from 'antd/lib/locale/zh_CN';
import enUS from 'antd/lib/locale/en_US';
import viVN from 'antd/lib/locale/vi_VN';

import { HelmetProvider } from 'react-helmet-async';

import { LANG_FROM_PATH } from './config/siteConfig';

import './index.css';

const theme = {
    components: {
        Menu: {
            darkItemBg: '#ffb700',
            darkItemSelectedBg: '#231916',
            darkItemColor: '#333',
            darkItemHoverColor: '#000',
            darkPopupBg: '#ffb700',
        },
    },
};

/**
 * 根据当前路径初始化 i18n 语言
 * - /zh/* → zh
 * - /vi/* → vi
 * - /en/* → en
 * - 其他（/、/about 等） → 保持 i18n 现状（detector 已用 localStorage / lng 默认决定）
 *
 * 必须在 i18n 初始化完成（'./i18n' 引入）后、首次渲染前同步设置
 * 这样 react-snap 预渲染时，i18n.t() 能返回正确语种
 */
const initI18nFromPath = (i18n) => {
    const pathLang = LANG_FROM_PATH(window.location.pathname);
    if (pathLang && i18n.language !== pathLang) {
        // 仅在路径明确指定语言（/zh/、/vi/、/en/）时才切换
        i18n.changeLanguage(pathLang);
    }
    // 无语言前缀时（/、/about/）保持 i18n 现状（detector 决定的语言）
    const currentLang = i18n.language;
    try {
        localStorage.setItem('lang', currentLang);
    } catch (_) { /* ignore */ }
    document.documentElement.lang = currentLang;
};

function WrappedApp() {
    const { i18n } = useTranslation();
    const getAntdLocale = () => {
        if (i18n.language.startsWith('zh')) return zhCN;
        if (i18n.language.startsWith('vi')) return viVN;
        return enUS;
    };
    const locale = getAntdLocale();

    // 路径驱动的语言初始化（路径优先于 localStorage）
    initI18nFromPath(i18n);

    return (
        <HelmetProvider>
            <ConfigProvider theme={theme} locale={locale}>
                <Router>
                    <App />
                </Router>
            </ConfigProvider>
        </HelmetProvider>
    );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<WrappedApp />);
